import React, { useEffect, useState } from "react";
import { useLanguageForShared } from "../../../../../../../shared/utils/languages/useLanguageForShared";
import { useTemplateFormConcentratorFixed } from "../data/useTemplateFormConcentratorFixed";
import { useTemplateFormOtherInfo } from "../data/useTemplateFormOtherInfo";
import { useParamsData } from "../data/useParamsData";
import { useEffectOnlyUpdate } from "../../../../../../../shared/utils/use_custom/useEffectCustom";
import { copyObject } from "../../../../../../../shared/utils/objUtils";
import { FormElements } from "../../../../../../../shared/bootstrap/form/FormElements";
import FormGroup from "../../../../../../../shared/bootstrap/form/form-group/FormGroup";
import InputCustom from "../../../../../../../shared/bootstrap/form/input/InputCustom";
import { useTemplateFormConcentratorPortable } from "../data/useTemplateFormConcentratorPortable";
import { useTemplateFormConcentratorTransportable } from "../data/useTemplateFormConcentratorTransportable";

const ConcentratorTemplateTransportable = ({ dataForm, changeValue, errors, setData, isSubmit }) => {
  const { t } = useLanguageForShared();
  const [sum, setSum] = useState();
  const {
    formStructurePulsedFlow, formStructureDetailPulsedFlow
  } = useTemplateFormConcentratorPortable(t, dataForm);
  const {
    formStructurePathologies,
    formStructureValid
  } = useTemplateFormConcentratorFixed(t, dataForm);
  const {
    formStructurePrescription
  } = useTemplateFormConcentratorTransportable(t, dataForm);
  const {
    formStructureCannulaNasal, formStructureMask,
    formStructureDetailCannulaNasal, formStructureDetailMask
  } = useTemplateFormOtherInfo(t, dataForm);
  const {
    formStructureNote
  } = useParamsData(t, dataForm);

  useEffectOnlyUpdate(() => {
    if (!dataForm?.cannulaNasal) {
      const modeField = formStructureDetailCannulaNasal.map((ele) => ele.name).join(",").split(",");
      const copyDataForm = copyObject(dataForm);
      modeField?.forEach((key) => {
        delete copyDataForm[key];
      });
      setData(copyDataForm);
    }
  }, [dataForm?.cannulaNasal]);

  useEffect(() => {
    if (!dataForm?.mask) {
      const modeField = formStructureDetailMask.map((ele) => ele.name).join(",").split(",");
      const copyDataForm = copyObject(dataForm);
      modeField?.forEach((key) => {
        delete copyDataForm[key];
      });
      setData(copyDataForm);
    }
  }, [dataForm?.mask]);
  useEffect(() => {
    if (!dataForm?.pulsedFlow) {
      const modeField = formStructureDetailPulsedFlow.map((ele) => ele.name).join(",").split(",");
      const copyDataForm = copyObject(dataForm);
      modeField?.forEach((key) => {
        delete copyDataForm[key];
      });
      setData(copyDataForm);
    }
  }, [dataForm?.pulsedFlow]);
  const getValue = (val) => {
    return val ? parseInt(val) : 0;
  };
  useEffect(() => {
    setSum(getValue(dataForm?.nightFlowHourDie) + getValue(dataForm?.underStressFlowHourDie) + getValue(dataForm?.flowRestHourDie));
  }, [dataForm?.nightFlowHourDie, dataForm?.underStressFlowHourDie, dataForm?.flowRestHourDie]);
  const changePathologyData = (data, val) => {

    if(dataForm?.pathology?.includes("Other") && data.name === 'pathology' && !data.value.includes("Other")){
      changeValue({
        value: {
          pathology:data.value,
          otherPathologies: ''
        }
      })
    } else {
      changeValue(data)
    }

  }
  return (
    <>
      <FormElements
        structure={formStructurePathologies}
        dataForm={dataForm}
        changeValue={changePathologyData}
        errors={errors}
        isSubmit={isSubmit}
      />

      <p className={"title-paragraph"}>{t('sg.prescription')}</p>
      <FormElements
        structure={formStructurePrescription}
        dataForm={dataForm}
        changeValue={changeValue}
        errors={errors}
        isSubmit={isSubmit}
      />

      <div className="row">
        <div className="col-sm-12 col-lg-3">
          <FormGroup
            label={{ label: t("prescription.template.check24h.label") }}
            error={{
              isVisible: sum > 24,
              message: t("prescription.template.check24h.error")
            }}
          >
            <InputCustom
              type={"text"}
              name={"check24h"}
              error={sum > 24}
              value={sum}
              disabled={true}
            />
          </FormGroup>
        </div>
        <div className="col-sm-12 col-lg-3">
          <FormElements
            structure={formStructureValid}
            dataForm={dataForm}
            changeValue={changeValue}
            errors={errors}
            isSubmit={isSubmit}
          />
        </div>
        <div className="col-sm-12">
          <FormElements
            structure={formStructurePulsedFlow}
            dataForm={dataForm}
            changeValue={changeValue}
            errors={errors}
            isSubmit={isSubmit}
          />
        </div>
      </div>

      <p className={"title-paragraph"}>{t('sg.otherInfo')}</p>
      <FormElements
        structure={formStructureCannulaNasal}
        dataForm={dataForm}
        changeValue={changeValue}
        errors={errors}
        isSubmit={isSubmit}
      />
      <FormElements
        structure={formStructureMask}
        dataForm={dataForm}
        changeValue={changeValue}
        errors={errors}
        isSubmit={isSubmit}
      />
      <FormElements
        structure={formStructureNote}
        dataForm={dataForm}
        changeValue={changeValue}
        errors={errors}
        isSubmit={isSubmit}
      />
    </>
  );
};

export default ConcentratorTemplateTransportable;
